import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveRemaFailure, saveRemaSuccess, updateRemaFailure, updateRemaSuccess } from './actions';

export function* saveRema({ payload }) {
  try {
    yield call(api.post, 'api/rema', payload.data, { withCredentials: true });

    yield put(saveRemaSuccess());

    toast.success('REMA criado com sucesso!')

    history.push('/specifications/pilar3/resources/rema');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveRemaFailure());
  }
}

export function* updateRema({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/rema/${id}`, payload.data, { withCredentials: true });

    yield put(updateRemaSuccess());

    toast.success('REMA atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/rema');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateRemaFailure());
  }
}

export default all([
  takeLatest('@rema/SAVE_REQUEST', saveRema),
  takeLatest('@rema/UPDATE_REQUEST', updateRema)
]);